import { useAtom } from "jotai";
import React from "react";

import { socialReferralPageAtom } from "../../social-referral.state";

interface ReferralStepsItem {
  title: string;
  description: string;
}

interface ReferralStepsItemProps {
  item: ReferralStepsItem;
  step: number;
}

const ReferralStep: React.FC<ReferralStepsItemProps> = ({ item, step }) => {
  return (
    <div className="referral-step__item">
      <span className="referral-step__number"> {step} </span>
      <div className="referral-step__text">
        <div className="referral-step__title"> {item.title} </div>
        <div className="referral-step__description"> {item.description} </div>
      </div>
    </div>
  );
};

export const ReferralStepsBullets: React.FC = () => {
  const [socialReferralPage] = useAtom(socialReferralPageAtom);

  const REFERRAL_STEPS: ReferralStepsItem[] = [
    {
      title: "Refer Friends",
      description:
        "Share your FindKeepLove giveaway referral link with friends",
    },
    {
      title: `Get ${socialReferralPage.social_referral_extra_entries} Entries Per Friend`,
      description: `You and your friend get ${socialReferralPage.social_referral_extra_entries} giveaway extra entries when they join`,
    },
    {
      title: "Keep It Up",
      description: "Keep collecting more entries for each friend you refer!",
    },
  ];

  return (
    <div className="referral-steps-bullets__view">
      {REFERRAL_STEPS.map((step: ReferralStepsItem, index) => {
        return <ReferralStep key={index} item={step} step={index + 1} />;
      })}
    </div>
  );
};
